export const ParingRateQueryID = "5667024915136512";
